import { useMemo } from "react";
import { useSelector } from "react-redux";
import { Navigate, Outlet, useLocation } from "react-router-dom";

import { RootState } from "../../redux/store";

const AuthRoutes = () => {
  const location = useLocation();
  const { isAuthenticated, prevUrl, user, lang } = useSelector(
    (state: RootState) => state.auth
  );

  const redirectPath = useMemo(() => {
    if (isAuthenticated) {
      // If we have a prevUrl, check if it's still valid for the current user's role
      if (prevUrl) {
        // Check if prevUrl contains a role that matches the user's current role
        const roleBasedPaths = ["user", "admin", "super-admin", "school-admin"];
        const containsRolePath = roleBasedPaths.some(
          (path) =>
            prevUrl.includes(`/${path}/`) || prevUrl.endsWith(`/${path}`)
        );

        // If prevUrl doesn't contain a role path, or contains the current user's role, use it
        if (!containsRolePath || prevUrl.includes(`/${user?.role}`)) {
          return prevUrl;
        }
      }

      // Fallback to default dashboard
      if (user?.role) {
        return user.role === "admin"
          ? `/${lang}/admin`
          : `/${lang}/${user.role}/dashboard`;
      }
    }

    return null;
  }, [isAuthenticated, prevUrl, user?.role, lang]);

  if (redirectPath) {
    return <Navigate to={redirectPath} replace state={{ from: location }} />;
  }

  return <Outlet />;
};

export default AuthRoutes;
